import React, {useState,  useEffect } from 'react';
import DeckGL, { MapView, PostProcessEffect } from 'deck.gl';
import { StaticMap } from 'react-map-gl';

import { renderLayers } from "./RenderLayers";


import shaderModule from './shaderModules/retoroCRT'


import styles from './Map.module.css';


const effect = new PostProcessEffect(shaderModule, {
    amount:1
});


// 背景マップに使用するMapboxのトークン設定
const MAPBOX_ACCESS_TOKEN = process.env.MAPBOX_ACCESS_TOKEN;

// 初期ビューポートの設定
const INITIAL_VIEW_STATE = {
    latitude: 40.70496049040556,
    longitude: -74.0120447808352,
    zoom: 15.5,
    pitch: 67.09970862979345,
    bearing: -14.467168998923576,
    maxPitch: 90
};


function Map() {
    const [viwState, setViewState] = useState(INITIAL_VIEW_STATE);

    return (
        <div 
            className={styles.MapWrapper}
        >
            <div
                className={styles.Aspect} 
            >
                <DeckGL
                    views={new MapView({ repeat: true })}
                    effects={[effect]}
                    initialViewState={viwState}
                    controller={true}
                    layers={renderLayers({})}
                    //onViewStateChange={({viewState}) => console.log(viewState)}
                >
                </DeckGL>
            </div>
            <div id="logo">
                <a href="https://google.com" target="_blank" alt="Google">
                    <img alt="Google" src="img/google_on_non_white_hdpi-368415f0.png" />
                </a>
            </div>

            <div id="copyright">
            </div>            
        </div>
    );
}

export default Map;